import { auth } from '../app/firebase';

// Returns the headers that prove who the signed-in visitor is to the backend:
// `{ Authorization: 'Bearer <Firebase ID token>' }`, or `{}` when signed out.
// The token is never cached here; getIdToken() refreshes it when needed.
// Fail stance: any problem is treated as "signed out" so requests still go
// through (the backend then serves the logged-out tier).
export const getAuthHeaders = async () => {
	if (typeof window === 'undefined') return {};
	try {
		// Wait for Firebase to restore the saved session, otherwise a signed-in
		// visitor would be treated as signed out on page load.
		await auth.authStateReady();
		const currentUser = auth.currentUser;
		if (!currentUser) return {};
		const token = await currentUser.getIdToken();
		return token ? { Authorization: `Bearer ${token}` } : {};
	} catch (error) {
		console.error('Failed to get Firebase ID token:', error);
		return {};
	}
};
